
export type TJSErrorParams<E extends Record<string, any> = {}> = E & {
  name: string;
  scope?: string | undefined;
  message: string;
  parent?: any;
  /**
   * Use this to flag errors that are safe and that we don't
   * need to log
   */
  shouldSkipLogs?: boolean;
};

export const UNKNOWN_ERROR_NAME = 'UnknownError';
export const UNKNOWN_ERROR_SCOPE = undefined;
export const UNKNOWN_ERROR_MESSAGE = (from: string) => `Could not identify error type from ${from}`;
